import {DocumentService} from 'src/app/core/services/document.service';
import {AfterViewInit, Component, Inject, OnInit, Renderer2, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Subscription} from 'rxjs';
import {SCREEN_SIZE} from 'src/app/core/constants/screen-size';
import {NotificationService} from 'src/app/core/services/notification.service';
import {Message} from 'src/app/core/class/message';
import {WarningComponent} from "../../../../../../../shared/components/warning/warning.component";
import {MatDialog} from "@angular/material/dialog";
import {Paginate} from "../search-document-contract-moha.component";
import {CommonService} from "../../../../../../../core/services/common.service";
import {EnumContractStatus} from "../../../../../../../core/constants/contract";
import {BlockUI, NgBlockUI} from "ng-block-ui";
import {ProcessingService} from "../../../../../../../core/services/processing.service";
import {ToastrService} from "ngx-toastr";
import {MatInput} from "@angular/material/input";

@Component({
  selector: 'app-popup-cancel-flow-moha',
  templateUrl: './popup-cancel-flow-moha.component.html',
  styleUrls: ['./popup-cancel-flow-moha.component.scss']
})
export class ListPopupCancelFlowComponent implements OnInit ,AfterViewInit{
  @BlockUI() blockUI: NgBlockUI;
  @ViewChild('focusInput', {static: false}) focusInput: MatInput;
  // @ViewChildren('focusInput') focusInput;
  // @ViewChild('textareaId', { static: false }) textareaRef: ElementRef;
  listDataPopup = [];
  listDataTotal = [];
  listData = [];
  isStop = false;
  timeOut: any;
  subTitle: string;
  isProcess = false;
  isShowProgress = false;
  dataSelected = [];
  checkAll: boolean;
  inputReasonValue:any;
  disable=false;
  paginate: Paginate;
  page = 0;
  pageSize = 10;
  percent: 0;
  checkReasonValue = false;
  isNotAttestedUser: boolean = false;
  enumContractStatus = EnumContractStatus;
  // Number of checked documents
  public countCheck = 0;
  constructor(
    public dialogRef: MatDialogRef<ListPopupCancelFlowComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService,
    private documentService: DocumentService,
    private processingService: ProcessingService,
    private renderer: Renderer2,
    private toastr: ToastrService,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    private message: Message,

  ) {
    // them chuc nang close message băng Esc vaf click chuot
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
    dialogRef.disableClose = false;
    if(!this.isNotAttestedUser){
      this.columnDefinitions = [
        { def: 'STT', showMobile: true },
        {def: 'Document', showXS: true, showSM: true, showMD: true},
        {def: 'UserSign', showXS: true, showSM: true, showMD: true},
        {def: 'result', showXS: true, showSM: true, showMD: true},
        {def: 'detail', showXS: true, showSM: true, showMD: true},
      ];
    }
    this.getDisplayedColumns();
  }

  columnDefinitions = [
    { def: 'STT', showMobile: true },
    {def: 'Document', showXS: true, showSM: true, showMD: true},
    {def: 'UserSign', showXS: true, showSM: true, showMD: true},
    {def: 'status', showXS: true, showSM: true, showMD: true},
    {def: 'result', showXS: true, showSM: true, showMD: true},
    {def: 'detail', showXS: true, showSM: true, showMD: true},

  ];
  displayedColumns: string[] = [];
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  ngOnInit() {
    this.listDataPopup = [];
    this.listDataTotal = [];
    this.listDataTotal = Array.from(this.data.dataSelected.values());
    this.listDataPopup = this.listDataTotal.filter((v: any) => (v.status === 2 || v.status === 9));
    if (this.data.isProcess && this.listDataPopup.length === 0) {
      // this.listDataPopup = JSON.parse(localStorage.getItem("listDataPopupCancel"));
      this.onProcessing();
    }
    else {
      this.listDataPopup.forEach((ele ,i) => {
        if(i < 10){
          this.listData.push(ele);
        }
        ele.order = i+1;
      });
      this.paginate = {
        currentPage: this.page,
        pageSize: this.pageSize,
        totalRow: this.listDataPopup.length,
        totalPage: Math.ceil(this.listDataPopup.length / this.pageSize),
        totalPageArray: this.counter(Math.ceil(this.listDataPopup.length / this.pageSize), 1),
        no: this.counter(this.pageSize, this.page * this.pageSize + 1)
      };
    }
    if (this.data.isProcess) {
      this.subTitle = '';
    } else {
      if (this.isNotAttestedUser) {
        const subTitleStr = this.commonService.format(this.message.getMessage('messages.confirm_cancel_flow_list_docs_draft'), this.listDataTotal.length - this.listDataPopup.length, this.listDataTotal.length, this.listDataPopup.length);
        this.subTitle = this.listDataPopup.length === this.listDataTotal.length ? '' : subTitleStr;
      } else {
        const subTitleStr = this.commonService.format(this.message.getMessage('messages.confirm_cancel_flow_list_docs_draft_1'), this.listDataTotal.length - this.listDataPopup.length, this.listDataTotal.length, this.listDataPopup.length);
        this.subTitle = this.listDataPopup.length === this.listDataTotal.length ? '' : subTitleStr;
      }
    }
    this.onProcessing();
    this.isProcess = this.data.isProcess ? this.data.isProcess : false;
    this.isShowProgress = this.isProcess;
    this.inputReasonValue = this.data.inputReasonValue ? this.data.inputReasonValue : ''
    if (JSON.parse(localStorage.getItem("inputReasonValue"))) {
      this.inputReasonValue = JSON.parse(localStorage.getItem("inputReasonValue"));
    }
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.focused = true);
  }

  onFilterData(page: number = 0, pageSize: number = 10) {
    this.listData = [];
    let a = page * pageSize ;
    this.listDataPopup.forEach((ele ,i) => {
      if(a <= i  && i < a + pageSize){
        this.listData.push(ele);
      }
    });
    this.paginate = {
      currentPage: page,
      pageSize: pageSize,
      totalRow: this.listDataPopup.length,
      totalPage: Math.ceil(this.listDataPopup.length / pageSize),
      totalPageArray: this.counter(Math.ceil(this.listDataPopup.length / pageSize), 1),
      no: this.counter(pageSize, page * pageSize + 1)
    };
  }

  onNoClick() {
    this.dialogRef.close();
  }
  counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }
  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showXS)
        .map(cd => cd.def);
    } else {
      if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
        this.displayedColumns = this.columnDefinitions
          .filter(cd => cd.showMD)
          .map(cd => cd.def);
      } else {
        this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
      }

    }
  }

  /**
   * check box change event.
   * @param item document item.
   * @param isChecked status of checkbox.
   */

  onClickConfirmButton() {
    if(this.inputReasonValue){
      const dialogRef = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.commonService.format(this.message.getMessage('messages.cancel_flow'), this.listDataPopup.length)
      });
      dialogRef.afterClosed().subscribe(rss => {
        if (rss) {
          this.disable = true;
          this.processingService.processingMultiSign.next(0);
          this.blockUI.reset();
          this.blockUI.start('');
          this.listDataPopup.forEach(ele =>{
            ele.statusName = 'CANCEL';
          })
          this.onFilterData(this.page,this.pageSize);
          const body = this.listDataPopup.map(item => {
            return item.id;
          });
          localStorage.setItem("listDataPopupCancel", JSON.stringify(this.listDataPopup));
          localStorage.setItem("inputReasonValue", JSON.stringify(this.inputReasonValue));
          this.documentService.deleteLotCancelFlow({contractIds:body,message:this.inputReasonValue})
            .subscribe({
              next: rs => {
                if (rs && rs.success) {
                  this.isProcess = true;
                  this.isShowProgress = true;
                  this.processingService.processingMultiSignStatus.next(this.isProcess);
                  this.processingService.processingCheckMan.next(2);
                  localStorage.setItem('checkMan', '2' );
                  this.processingService.processingInputReasonValue.next(this.inputReasonValue);
                  this.data.signContractId = rs.data;
                  this.data.onClickConfirmButtonCancel();
                  this.onProcessing();
                  this.blockUI.stop();
                } else {
                  this.blockUI.stop();
                  this.toastr.error(rs.message);
                }
              },
              error: err => {
                this.blockUI.stop();
              }
            });
        } else {
          dialogRef.close();
        }
      });
    }
    else {
      this.checkReasonValue = true;
    }

  }
  onClickCancelButton() {
    this.dialogRef.close();
  }
  renderStatus(status: string) {
    switch (status) {
      case 'ERROR':
        return this.message.getMessage('sign_contract_flow.error');
      case 'PROCESSING':
      case 'CANCEL':
        return this.message.getMessage('sign_contract_flow.process');
      case 'DONE':
        return this.message.getMessage('sign_contract_flow.success');
      default:
        return '';
    }
  }
  renderStatusColor(status: string): object {
    switch (status) {
      case 'ERROR':
        return {'color': 'red', 'border': '1px solid red', 'border-radius': '5px'};
      case 'PROCESSING':
      case 'CANCEL':
        return {'color': 'blue', 'border': '1px solid blue', 'border-radius': '5px'};
      case 'DONE':
        return {'color': 'green', 'border': '1px solid green', 'border-radius': '5px'};
      default:
        return {};
    }
  }
  onClickStopSign() {
    // show confirm poup.
    const popup = this.dialog.open(WarningComponent, {
      width: '30%',
      data: 'messages.sign_multi_stop_cancel'
    });

    popup.afterClosed().subscribe(rs => {
      if (rs) {
        // call to server for stopping sign.
        const signContractId = this.data.signContractId;
        this.isStop = true;
        this.documentService.CancelContractFlowCancel(signContractId).subscribe(
          (res) => {
            if (res && res.success) {
              this.processingService.processingMultiSignStatus.next(false);
              this.processingService.processingCheckMan.next(2);
              localStorage.setItem('checkMan', '2' );
              this.processingService.processingInputReasonValue.next(this.inputReasonValue);
              this.processingService.processingMultiSignCancel.next(this.isStop);
              this.isShowProgress = false;
              this.documentService.signContractFlowInfo(signContractId).subscribe(res => {
                if (!res || !res.data.lotDetails) {
                  return;
                }
                // this.listDataPopup = this.getCommonElements(res.data.lotDetails,this.listDataPopup);
                this.listDataPopup = res.data.lotDetails;
                this.listDataPopup.forEach(ele => {
                  if(!ele.statusName){
                    ele.statusName = ele.status;
                    ele.status = ele.statusContract
                  }
                  // res.data.lotDetails.forEach(ala => {
                  //   if(ele.id === ala.contractId ){
                  //     if(ala.errorMessage){
                  //       ele.errorMessage = ala.errorMessage;
                  //     }
                  //     if(ala.status){
                  //       if(ala.status == 'DONE') {
                  //         ele.status = 5;
                  //       }
                  //       ele.statusName = ala.status;
                  //     }
                  //   }
                  // })
                })
                this.onFilterData(this.page,this.pageSize)
              });
              this.toastr.success(this.message.getMessage('messages.cancel_multi_stop'));
              localStorage.removeItem("inputReasonValue");
              this.processingService.processingInputReasonValue.next('');
            } else {
              this.toastr.error(this.message.getMessage('messages.sign_cancel_stop_fail'));
              localStorage.removeItem("inputReasonValue");
              this.processingService.processingInputReasonValue.next('');
            }
          },
          (err) => {
          },
          () => {
          }
        );
      }
    });
  }
  getCommonElements(array1,array2){
    const idMap = {};
    array1.forEach((ele,i) => {
      idMap[ele.contractId] = i;
    })
    const commonElements = [];
    array2.forEach(ala => {
      if (idMap.hasOwnProperty(ala.id)){
        commonElements.push(ala);
      }
    });
    return commonElements;
  }

  onProcessing() {
    if (this.data.signContractId) {
      this.documentService.signContractFlowInfo(this.data.signContractId).subscribe(res => {
        if (!res || !res.data.lotDetails) {
          return;
        }
        // this.listDataPopup = this.getCommonElements(res.data.lotDetails,this.listDataPopup);
        this.listDataPopup = res.data.lotDetails;
        this.listDataPopup.forEach(ele => {
          if(!ele.statusName){
            ele.statusName = ele.status;
            ele.status = ele.statusContract
          }
          // res.data.lotDetails.forEach(ala => {
          //   if(ele.id === ala.contractId ){
          //     if(ala.errorMessage){
          //       ele.errorMessage = ala.errorMessage;
          //     }
          //     if(ala.status){
          //       if(ala.status == 'DONE') {
          //         ele.status = 5;
          //       }
          //       ele.statusName = ala.status;
          //     }
          //   }
          // })
        })
        this.onFilterData(this.page,this.pageSize)
      });
    }
    const proccesingTaskSub = this.processingService.processingMultiSign.subscribe(ref => {
      const process = ref;
      if (process > 0) {
        this.percent = process;
        if (this.data.signContractId) {
          this.documentService.signContractFlowInfo(this.data.signContractId).subscribe(res => {
            if (!res || !res.data.lotDetails) {
              return;
            }
            // this.listDataPopup = this.getCommonElements(res.data.lotDetails,this.listDataPopup);
            this.listDataPopup = res.data.lotDetails;
            this.listDataPopup.forEach(ele => {
              if(!ele.statusName){
                ele.statusName = ele.status;
                ele.status = ele.statusContract
              }
              // res.data.lotDetails.forEach(ala => {
              //   if(ele.id === ala.contractId ){
              //     if(ala.errorMessage){
              //       ele.errorMessage = ala.errorMessage;
              //     }
              //     if(ala.status){
              //       if(ala.status == 'DONE') {
              //         ele.status = 5;
              //       }
              //       ele.statusName = ala.status;
              //     }
              //   }
              // })
            })
            this.onFilterData(this.page,this.pageSize)
          });
        }
        if (process === 100 && this.data.signContractId) {
          this.documentService.signContractFlowInfo(this.data.signContractId).subscribe(res => {
            if (!res || !res.data.lotDetails) {
              return;
            }
            // this.listDataPopup = this.getCommonElements(res.data.lotDetails,this.listDataPopup);
            this.listDataPopup = res.data.lotDetails;
            this.listDataPopup.forEach(ele => {
              if(!ele.statusName){
                ele.statusName = ele.status;
                ele.status = ele.statusContract
              }
              // res.data.lotDetails.forEach(ala => {
              //   if(ele.id === ala.contractId ){
              //     if(ala.errorMessage){
              //       ele.errorMessage = ala.errorMessage;
              //     }
              //     if(ala.status){
              //       if(ala.status == 'DONE') {
              //         ele.status = 5;
              //       }
              //       ele.statusName = ala.status;
              //     }
              //   }
              // })
            })
            this.onFilterData(this.page,this.pageSize)
          });
          this.isStop = true;
          this.timeOut = setTimeout(() => {
            this.isShowProgress = false;
          }, 2000);
        }
      }
    });
  }
  changeReason(){
    if(this.inputReasonValue){
      this.checkReasonValue = false;
    }
    else {
      this.checkReasonValue =true;
    }
  }
}
